import Image from 'next/image'
import Link from 'next/link'
import { IoRocketOutline } from 'react-icons/io5'
import HeaderImage from '/public/HRMS-Portals/headerImage.png'

const Header = () => {
    return (
        <header className='flex min-h-[calc(100vh-15rem)] flex-col gap-4 bg-[#FFEAEA] px-5 pt-32 pb-12 font-bold md:flex-row md:gap-0 md:px-12 lg:pt-32'>
            <div className='flex flex-1 flex-col items-start justify-center gap-4'>
                <h1 className='text-center text-4xl leading-[120%] md:text-left lg:text-6xl'>
                    Unlock Seamless HR Management with{' '}
                    <span className='text-[#FF3B38]'>HRMSPORTALS</span>
                </h1>
                <div className='flex flex-1 items-center justify-center md:hidden'>
                    <Image className='mx-auto w-[calc(100%-2rem)]' src={HeaderImage} alt='Header' />
                </div>
                <h3 className='mx-auto text-center text-base font-semibold md:mx-0 md:text-left lg:text-lg'>
                    A smarter way to manage employees, payroll, leaves and recruitment All in One
                    Place.
                </h3>
                <Link href='https://hrmsportals.com/' target='_blank' className='mx-auto md:mx-0'>
                    <button className='flex items-center gap-3 bg-[#FF3B38] py-2 px-4 font-semibold  transition-all duration-300 ease-outout hover:scale-105 hover:bg-[#FF3B38]  text-white shadow-[2px_2px_12px_0px_#00000026]'>
                        <IoRocketOutline className='text-2xl' />
                        Get Started
                    </button>
                </Link>
            </div>
            <div className='hidden flex-1 items-center justify-center md:flex'>
                <Image
                    className='min-w-[20rem] md:w-full lg:w-full'
                    src={HeaderImage}
                    alt='Header'
                />
            </div>
        </header>
    )
}

export default Header
